
import React from "react";

const InvitationSteps = () => {
  return (
    <div className="flex items-center mt-6">
      <div className="flex items-center">
        <div className="h-6 w-6 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs">
          1
        </div>
        <span className="ml-2 text-sm font-medium text-blue-500">Sélectionner une organisation</span>
      </div>
      <div className="h-px w-6 bg-gray-300 mx-2"></div>
      <div className="flex items-center">
        <div className="h-6 w-6 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs">
          2
        </div>
        <span className="ml-2 text-sm font-medium text-blue-500">Ajouter des emails</span>
      </div>
      <div className="h-px w-6 bg-gray-300 mx-2"></div>
      <div className="flex items-center">
        <div className="h-6 w-6 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center text-xs">
          3
        </div>
        <span className="ml-2 text-sm font-medium text-gray-500">Envoyer les invitations</span>
      </div>
    </div>
  );
};

export default InvitationSteps;
